import { OlTeflPriceFilters } from '../../types/models/ol/tefl-price/ol-tefl-price'

export const transformOlTeflPriceFiltersToUrl = (filters?: OlTeflPriceFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.formulas && filters.formulas.length > 0)
    searchParams.set('formulas', filters.formulas.join(','))
  if (filters.periods && filters.periods.length > 0)
    searchParams.set('periods', filters.periods.join(','))

  return searchParams.toString()
}

export const transformUrlToOlTeflPriceFilters = (
  searchParams: URLSearchParams
): OlTeflPriceFilters => {
  const filters: OlTeflPriceFilters = {}

  const formulas = searchParams.get('formulas')
  if (formulas) filters.formulas = formulas.split(',').map(Number)

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',')

  return filters
}
